import { privateAxiosIntance } from "../../Config/axios";
import { protectedRoutes } from "../../Config/urls";

export const getYoutubeFolderFn = () => {
    try {
        const response = privateAxiosIntance.get(protectedRoutes.youtubeFolder);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getYoutubeFolderByIdFn = (id) => {
    try {
        console.log("ids", id)
        const response = privateAxiosIntance.get(`${protectedRoutes.youtubeFolder}`, {
            params: id
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteYoutubeFolderByIdFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.delete(`${protectedRoutes.youtubeFolder}`, { data: reqBody });
        return response;
    } catch (error) {
        throw error;
    }
}

export const postYoutubeFolderFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.post(protectedRoutes.youtubeFolder, reqBody);
        return response;
    } catch (error) {
        throw error;
    }
}

export const patchYoutubeFolderFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.patch(protectedRoutes.youtubeFolder, reqBody);
        return response;
    } catch (error) {
        throw error;
    }
}



// Youtube Links......
export const getYoutubeLinkFn = (req) => {
    try {
        const response = privateAxiosIntance.get(protectedRoutes.Youtube_link, { params: req });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getYoutubeLinkByIdFn = (id) => {
    try {
        const response = privateAxiosIntance.get(`${protectedRoutes.Youtube_link}?video_url_id=${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteYoutubeLinkeByIdFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.delete(`${protectedRoutes.Youtube_link}`, { data: reqBody });
        return response;
    } catch (error) {
        throw error;
    }
}

export const postYoutubeLinkFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.post(protectedRoutes.Youtube_link, reqBody);
        return response;
    } catch (error) {
        throw error;
    }
}

export const patchYoutubeLinkFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.patch(protectedRoutes.Youtube_link, reqBody);
        return response;
    } catch (error) {
        throw error;
    }
}